import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { RequestEntity, IItemGame } from 'types';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Game.module.scss';

interface IGame {
	data: IItemGame;
}

const Game: React.FC<IGame> = ({ data }) => {
	const { setIDsSelectedGame, IDsSelectedGame } = useContext<IGameAssignmentContext>(GameAssignmentContext);
	const checkCheckbox = () => IDsSelectedGame.includes(data.id);
	const isCheckedCheckbox = useMemo(() => checkCheckbox(), [data, IDsSelectedGame]);
	const isAssigned = !!data.restaurants.length;

	const containerClasses = classNames(style.container, {
		[style.checkedCheckbox]: isCheckedCheckbox,
		[style.assigned]: isAssigned,
	});

	const handleChange = (value: boolean) => {
		if (value) {
			setIDsSelectedGame([...IDsSelectedGame, data.id]);
		} else {
			const updateGameList = IDsSelectedGame.filter((el) => el !== data.id);
			setIDsSelectedGame(updateGameList);
		}
	};

	return (
		<div className={containerClasses} data-test="Game">
			<div className={style.name}>
				<Checkbox
					className={style.checkbox}
					onChange={(e) => handleChange(e.target.checked)}
					checked={isCheckedCheckbox}
				/>
				<div className={style.imgWrapper}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Games}
						entityID={data.iconPath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text
					className={style.gameName}
					translationNameSpace="listing"
					translationKey={data.name}
					withTooltip={true}
				/>
			</div>
		</div>
	);
};

export default Game;
